import { useSelector } from 'react-redux';
import {
  ruler2dTimestampRangeSelector,
  ruler2dVoltageRangeSelector,
} from '../selectors/ruler2d.selectors';
import { useStrip } from '../../plot/hooks/useStrip';

export const useRuler2dDimensions = () => {
  const { xScale, yScale } = useStrip();
  const [ruler2dStart, ruler2dEnd] = useSelector(ruler2dTimestampRangeSelector);
  const [voltageStart, voltageEnd] = useSelector(ruler2dVoltageRangeSelector);

  return {
    x: xScale(ruler2dStart),
    y: yScale(voltageStart),
    width: xScale(ruler2dEnd - ruler2dStart),
    height: yScale(voltageEnd - voltageStart),
  };
};
